import script from "./CustomerDictionaryItemsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerDictionaryItemsModal.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerDictionaryItemsModal.vue?vue&type=style&index=0&id=6a6a0434&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6a0434"]])

export default __exports__